
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prospetti-e-rendiconti/[slug]",
      function () {
        return require("private-next-pages/prospetti-e-rendiconti/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prospetti-e-rendiconti/[slug]"])
      });
    }
  